import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ReactTimeAgo from "react-time-ago";
import TimeAgoJS from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ru from "javascript-time-ago/locale/ru";
TimeAgoJS.addDefaultLocale(en);
TimeAgoJS.addLocale(ru);
var TimeAgo = function (_a) {
    var date = _a.date;
    return (_jsx(_Fragment, { children: date && _jsx(ReactTimeAgo, { date: new Date(date), locale: "en-US", tooltip: false }) }));
};
export default TimeAgo;
